<span class="user-login-logout-container">
  <span *ngIf="loggedIn === true && this.currentUser !== undefined && this.isToolAccess === true">
    <!--<select class="form-control">
    <option>TEst</option>
  </select>-->
    <span *ngIf="this.countryList.length > 0" style="padding-right: 1.5rem; width: 150px; display: inline-flex">
      <select
        class="form-control form-select"
        style="height: 100%"
        id="user-country-list"
        name="usercountrylist"
        [(ngModel)]="this.selectedCountryId"
        (change)="onCountryChanged()"
        appLabelFloat
        tabindex="1"
      >
        <option [value]="undefined" disabled selected="selected"></option>
        <option *ngFor="let country of countryList" [ngValue]="country.countryId">{{ country.countryName }}</option>
      </select>
      <!--<label for="usercountrylist">Country</label>-->
    </span>
    <span>
      <a
        title="User: {{ currentUser?.displayName }} - ({{ currentUser?.userPrincipalName }}, Country: {{
          navigationService.userCountry?.countryName
        }})"
      >
        <i class="ey-menu-icon material-icons person-icon">person</i>
        <span class="text">{{ this.currentUser.givenName }}</span>
      </a></span
    >
    <!-- <span>
      <a><i class="ey-menu-icon material-icons logout-icon">exit_to_app</i></a></span
    > -->
    <span>
      <a
        tabindex="1"
        href
        class="logout-btn"
        title="Logout User: {{ currentUser?.displayName }} - ({{ currentUser?.userPrincipalName }})"
        (click)="$event.preventDefault(); logOut()"
      >
        <i class="ey-menu-icon material-icons logout-icon">exit_to_app</i>
        <span class="logout-text">Logout</span>
      </a>
    </span>
  </span>
</span>
